var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJogadores(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8885 4.35899C12.7837 4.35899 13.5094 3.63329 13.5094 2.73809C13.5094 1.84289 12.7837 1.11719 11.8885 1.11719C10.9933 1.11719 10.2676 1.84289 10.2676 2.73809C10.2676 3.63329 10.9933 4.35899 11.8885 4.35899Z",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18617 9.46391C3.62646 9.7872 2.91004 9.59555 2.58676 9.03495C2.26347 8.47525 2.45512 7.75883 3.01572 7.43555",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6037 10.2039C16.6013 10.2039 17.307 8.95646 16.2467 7.93645C16.1983 7.88988 16.1339 7.86212 16.0667 7.86212H13.4571C13.3944 7.86212 13.3344 7.83884 13.287 7.79764L10.6317 5.43167C10.5852 5.38958 10.5243 5.36719 10.4616 5.36719H6.47472C6.42815 5.36719 6.38158 5.37972 6.34128 5.4048L3.01172 7.43675",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54273 17.8421C8.28751 18.4358 8.56154 19.1245 9.15617 19.3797C9.75079 19.6349 10.4386 19.3609 10.6938 18.7662L12.5278 14.6083C12.5278 14.6083 12.7768 14.1095 12.6944 13.7773C12.612 13.445 12.5278 13.1952 12.1123 12.9462L9.64602 11.405C9.53587 11.3361 9.49467 11.1955 9.55109 11.0781L10.4842 9.12769C10.5559 8.97725 10.7502 8.93516 10.8774 9.04172L12.2063 10.145C12.252 10.1826 12.3102 10.2041 12.3693 10.2041H15.6013",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99647 14.5903C1.38931 14.8115 1.07587 15.484 1.29796 16.0912C1.51916 16.6983 2.1917 17.0118 2.79887 16.7897L7.53441 14.8939C7.59262 14.8706 7.64008 14.8267 7.66784 14.7712L8.24456 13.6177C8.31262 13.4816 8.48456 13.435 8.61262 13.5174L9.85292 14.3234C9.9577 14.3915 9.998 14.5258 9.94785 14.6404L8.53919 17.8491",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18445 9.46617L7.02416 7.74765C7.06446 7.72348 7.11013 7.71094 7.1567 7.71094H8.08805C8.277 7.71094 8.40059 7.90975 8.3173 8.079L5.92356 12.9417C5.8958 12.9981 5.84834 13.0429 5.78923 13.0662L1.94922 14.6092",
    stroke: "black",
    strokeWidth: 0.619961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJogadores);
export default __webpack_public_path__ + "static/media/Jogadores.00e3747596a15931912c16613409ae68.svg";
export { ForwardRef as ReactComponent };